// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var ChannelControllerPriority = 500;
//# sourceMappingURL=Constants.js.map